export const darkColors = {
  primary: 'rgb(128, 222, 234)',
  secondary: 'rgb(255, 171, 145)',
  text: {
    primary: 'rgb(128, 222, 234)',
    secondary: 'rgba(128, 222, 234,0.8)',
    disabled: 'rgba(128, 222, 234,0.5)',
    hint: 'rgba(128, 222, 234,0.5)'
  },
  background: {
    default: 'rgb(26, 26, 26)',
    paper: 'rgb(26, 26, 26)',
    paperTrans: 'rgba(0, 0, 0, 0.1)'
  },
  backdrop: 'rgba(26, 26, 26, 0.75)',
  scrollbar: {bar: 'rgba(128, 222, 234,1)', back: 'rgba(128, 222, 234,0.2)'},
  divider: 'rgba(128, 222, 234,0.2)',
  shadow: 'rgba(128, 222, 234, 0.7)',
  charts: {
    lineColor: 'rgba(128, 222, 234,0.3)',
    splitColor: 'rgba(128, 222, 234,0.1)',
    labelColor: 'rgba(0,0,0,0.8)'
  }
} as const;

export const lightColors = {
  primary: 'rgb(33, 150, 243)',
  secondary: 'rgb(255, 87, 34)',
  text: {
    primary: 'rgb(0,0,0)',
    secondary: 'rgba(0,0,0,0.8)',
    disabled: 'rgba(0,0,0,0.45)',
    hint: 'rgba(0,0,0,0.45)'
  },
  background: {
    default: 'rgb(229, 229, 229)',
    paper: 'rgb(229, 229, 229)',
    paperTrans: 'rgba(255, 255, 255, 0.1)'
  },
  backdrop: 'rgba(229, 229, 229, 0.75)',
  scrollbar: {bar: 'rgba(33, 150, 243,1)', back: 'rgba(33, 150, 243,0.2)'},
  divider: 'rgba(0,0,0,0.2)',
  shadow: 'rgba(0, 0, 0, 0.3)',
  charts: {
    lineColor: 'rgba(0,0,0,0.3)',
    splitColor: 'rgba(0,0,0,0.05)',
    labelColor: 'rgba(0,0,0,0.8)'
  }
} as const;

export type ColorSet = {
  primary: string;
  secondary: string;
  text: {
    primary: string;
    secondary: string;
    disabled: string;
    hint: string;
  };
  background: {
    default: string;
    paper: string;
    paperTrans: string;
  };
  backdrop: string;
  scrollbar: {bar: string; back: string};
  divider: string;
  shadow: string;
  charts: {
    lineColor: string;
    splitColor: string;
    labelColor: string;
  };
};

export const getColorsByMode = (mode: 'dark' | 'light'): ColorSet =>
  mode === 'dark' ? darkColors : lightColors;

export const chartSeriesColors = [
  '#00BFFF',
  '#FF69B4',
  '#9ACD32',
  '#48D1CC',
  '#D8BFD8',
  '#FF6347',
  '#00FA9A',
  '#FFC300',
  '#9932CC',
  '#FFA07A',
  '#ADD8E6',
  '#ADFF2F',
  '#FFDAB9',
  '#1E90FF',
  '#FF8C00',
  '#E6E6FA',
  '#FFC0CB',
  '#FFD700',
  '#BA55D3',
  '#FFA500',
  '#6A5ACD',
  '#D3D3D3',
  '#CD5C5C',
  '#FF1493',
  '#FFB6C1'
] as const;
